import { Component, ViewChild, OnInit,Injectable,Input,ElementRef,NgModule } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { AgGridAngular} from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Core/services/auth.service';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/Core/services/user.service';


interface User {
  id: number;
  name: string;
  brand: string;
  notify: any;
  pioneer: boolean;
  verified_email: string;
  ayla_email: string;
  created: string;
  alexaenabled: boolean;
  logenabled: boolean;
  device_types: any;
}

interface ResponseData {
  items: User[];
  pager: {
    total: number;
    per_page: number;
    current: number;
  };
}

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail-ctl.component.html',
  styleUrls: ['./user-detail-ctl.component.css'],
})

@Injectable({
  providedIn : 'root'
})



export class UserDetailComponent {
  pageSizeOptions: number[] = [5, 10, 15, 20];
  user: any='';
  locations: any[]=[];
  devices: any[]=[];
  data: any='';
  key: any;
  private apiURL='';
  pageSize: number;
  defaultPlaceholder: string="10 items per page";
  dataFetched : boolean = false;
  @Input() searchQuery: string = '';
 
  constructor(
    private http: HttpClient,
    private router: Router,
    private authService:AuthService,
    private userService: UserService  
  ) {
    this.key=this.authService.getToken();
    this.pageSize = 10;
  }

  //ag grid code

  rowData: any[]=[]

  // columnDefs: ColDef[] = [
  //   {lockPosition:'left', headerName: 'ID', field: 'id' },
  //   {lockPosition:'left',headerName: 'Name', field: 'name' , 
  //   cellRenderer(params: any): string {
  //     const clickedUserID = params.data.id; // Assuming you have a unique identifier called 'id' in your data
  //     const link = `<a (click)="navigateToUserInfo(${clickedUserID})">${params.value}</a>`;
  //     return link;
  //   }},
  //   {lockPosition:'left',headerName: 'Verified E-Mail', field: 'verified_email' },
  //   {lockPosition:'left',headerName: 'Brand', field: 'brand' }
  // ];
  // public defaultColDef: ColDef ={
  //   flex: 1,
  //   minWidth:25,
  //   resizable:true,
    
  //   // floatingFilter:true,
  // };

  navigateToUserInfo(userID: string) {
    this.router.navigate(['/user-info',userID]);
  }

  makeApiRequestWithToken() {
    const modifiedSearchQuery = this.searchQuery.replace(/\+/g, '%2B');
    this.userService.fetchUsers(modifiedSearchQuery).subscribe(
      (fetchUsersresponses) => {
        this.rowData = fetchUsersresponses;
        this.dataFetched = true;
      },
      (error) => {
        console.error('Error fetching user details:', error);
        this.dataFetched = true;
      }
    );
  }
  
  

  
  onSearchClick(): void {
    if (this.isValidEmail(this.searchQuery)) {
      this.makeApiRequestWithToken();
    } else {
      alert('Please enter a valid email address.');
    }
  }
  
  isValidEmail(email: string): boolean {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  
  //pagination
 
  // currentPage: number = 1;
  // totalItems: number = 0;

 
  // goToPage(pageNumber: number) {
  //   this.currentPage = pageNumber;
  //   if (!this.searchQuery) {
  //     this.fetchUserDetails();
  //   } else {
  //     this.makeApiRequestWithToken();
  //   }
  // }

  // Update the API URL to include pagination parameters
  
  // Add a method to update the API URL with pagination parameters
//   updateApiURL() {
//     this.apiURL = `${environment.host}/user?page=${this.currentPage}&q=${this.searchQuery}`;
// }

  public rowData$!: Observable<User[]>;
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  @ViewChild('searchButton', { static: true }) searchButton!: ElementRef;


  userID:string='';
  
  pageLoaded : boolean =false;
 
//   ngOnInit(): void {
//     this.fetchUserDetails();
// }


// fetchUserDetails(): void {
//    this.userService.getAllUsers(this.pageSize, this.currentPage, this.searchQuery).subscribe(
//     (getAllUsersResponse) => {
//       if (getAllUsersResponse && getAllUsersResponse.items) {
//         this.rowData = getAllUsersResponse.items;
//         this.totalItems = getAllUsersResponse.pager.total;
//       } else {
//         this.rowData = [];
//         this.totalItems = 0;
//       }
//     },
//     (error) => {
//       console.error('Error fetching user details:', error);
//     }
//   );
// }



// nextPage(): void {
//   if (!this.searchQuery && this.currentPage < this.totalPages) {
//     this.currentPage++;
//     this.fetchUserDetails();
//   } else {
//     this.currentPage++;
//     this.makeApiRequestWithToken();
//   }
// }

// prevPage(): void {
//   if (!this.searchQuery && this.currentPage > 1) {
//     this.currentPage--;
//     this.fetchUserDetails();
//   } else {
//     this.currentPage--;
//     this.makeApiRequestWithToken();
//   }
// }

// onPageSizeChange(event: any): void {
//   this.pageSize = Number(event.value);
//   this.currentPage = 1;
//   if (!this.searchQuery) {
//     this.fetchUserDetails();
//   } else {
//     this.makeApiRequestWithToken();
//   }
//   this.updateApiURL();
// }
// get totalPages(): number {
//   return Math.ceil(this.totalItems / this.pageSize);
// }

  onCellClicked(event: CellClickedEvent): void {
    const clickedUserID = event.data.id;
    this.pageLoaded = true;
    this.router.navigate(['/user-info', clickedUserID]);
  }
}
